import { gql } from '../../../common/gql';

const intercomArticleQuery = gql(/* GraphQL */ `
  query IntercomArticleQuery($url: String!) {
    intercomArticle(url: $url)
  }
`);

export default intercomArticleQuery;
